export default {
  title: 'Job List',
  label: {
    all: 'All',
    totalCount: 'Search Result',
    selected: 'Selected',
    date: 'Date',
    refresh: 'Refresh Job Post Date',
    postToAgency: 'Post To Agency',
    setReferral: 'Setup Referral',
    generateSiteShare: 'Generate Career Site URL/QR Code',
    generateJobShare: 'Generate Job URL/QR Code',
    generateMobileShare: 'Generate Mobile Job List URL/QR Code',
    closeJob: 'Close Job',
    addCandidate: 'Add Individual Candidate',
    batchAddCandidate: 'Add Multiple Candidates (Batch Add) ',
    new: 'Unread',
    total: 'Total',
    screen: 'Screen',
    interview: 'Interview',
    offer: 'Offer',
    hired: 'Hired',
    leads: 'Leads',
    openDays: 'Days old',
    jobTitle: 'Job Title',
    recruiter: 'Recruiter/Coordinator',
    disabledRecruiter: 'Recruiter/Coordinator(Disabled)',
    jobLocation: 'Job Location',
    jobStatus: {
      label: 'Job Status',
      OPEN: 'Open Jobs',
      CLOSED: 'Closed Jobs',
      all: 'All Jobs',
      HOT: 'Hot Jobs',
      ON_HOT: 'On Hold Jobs',
      CANCEL: 'Cancelled Jobs'
    },
    myJobs: 'My Jobs',
    allJobs: 'All Jobs',
    postTo: 'Post To',
    postHistory: 'Post History',
    putAway: 'Put Away',
    shareToAgency: 'Post job to agency',
    shareDialogTitle: 'Generate the URL/QR code directly or add a custom "Source Name" and "Tracking Tag" so you can track your channel effectiveness.',
    sourceName: 'Source Name (e.g. Job Fair or Hiring Campaign etc.)',
    sourceDetail: 'Source Tag / Detail (e.g. Job Fair Date, Campaign Name etc.)',
    simpleSourceName: 'Source Name:',
    simpleCodeName: 'Source Tag / Detail:',
    jobInfo: 'Job Info',
    company: 'Company',
    postTaskTime: 'Start Date',
    postTaskStatus: 'Status',
    postTaskFinishTime: 'Finish Date',
    finished: 'Finished',
    inProgress: 'In progress',
    openJobDetail: 'View Job Detail',
    includeChildrenCompany: 'Including sub-companies',
    postChannel: 'Channel Posted',
    defaultChannelName: 'WeChat/Career Site',
    selectChannelAccount: 'Select Channel Account'
  },
  tips: {
    pageViews: 'Page View',
    share: 'Shares',
    more: 'More',
    hotJob: 'Hot Job',
    editJob: 'Edit Job',
    addJob: 'Add Job',
    closeJob: 'Close Job',
    openJob: 'Open Job',
    draft: 'Referral set up draft',
    pending: 'Referral pending approval',
    approve: 'Referral posted/live',
    rejected: 'Referral set up rejected',
    archived: 'Referral set up archived ',
    jobClosed: 'Oops! This job is currently closed. If you want to publish this job, first adjust the Job Close Date and then set the Job Status to “Active”.'
  },
  btn: {
    action: 'Action',
    publish: 'Publish',
    yes: 'Confirm',
    cancel: 'Cancel',
    channelDialog: {
      add: 'Auto Publish',
      update: 'Update',
      hide: 'Hide',
      unPublish: 'Close',
      cancel: 'Cancel',
      view: 'View',
      manualAdd: 'Self Publish'
    },
    agencyDialog: {
      sendEmailCreator: 'Please notice the JOB CREATOR when a new candidate is submitted',
      sendEmailCoordinator: 'Please notice the JOB COORDINATOR when a new candidate is submitted'
    },
    shareDialog: {
      download: 'Download',
      cancel: 'Cancel',
      copyUrl: 'Copy URL',
      createQRCode: 'Create QR Code'
    }
  },
  placeholder: {
    agency: 'Please select agency',
    agencyName: 'Name'
  },
  message: {
    hasNoPermission: 'Oops! It seems you do not have the user permissions to perform this function. Please contact your administrator or your AJINGA customer success consultant for support. ',
    jobCountNoEnough: 'Oops! It seems you have reached the maximum number of open jobs your user permissions allow. Please contact your administrator or your AJINGA customer success consultant for support. ',
    channelAlreadyAction: 'Posted on {channelName}',
    channelReadyPost: 'Currently being posted to {channelName}',
    channelReadyClose: 'Currently being closed on {channelName}',
    channelReadyRefresh: 'Currently being refreshed on {channelName}',
    confirmAction: 'Confirm the operation?',
    channelPostProcessing: 'Oops! The current task is still in progress. When this has been completed, you can submit your update.',
    notFoundPostingChannel: "Can't see your job board? Please contact your administrator or your AJINGA customer success consultant for support.",
    shareDialogTitleTip: 'When a candidate applies through a tagged URL/QR code, AJINGA can track the application and record the Source Channel and Source Tag / Details so you can understand the effectiveness of your candidate sourcing activities. <br/><br/>The Source Name is typically the name of the channel where you are promoting your URL/QR code e.g. “Job Fair” or “Hiring Campaign”.<br/><br/>If you need several links with the same or similar Source Name, you may also want to use the Source Tag / Detail field to record the specific details of the source channel. For example, if your Source Name is ”Job Fair” the Source Tag / Detail may be the date or season of the job fair e.g. “Spring 2024”. If your Source Name is “Hiring Campaign” the Source Tag / Detail may be “WeChat Moments Advertisement 2024.7.15”.',
    sourceNameTip: "Not all users have the authority to create their own source name. If you don’t see your source name in the drop-down list and are unable to create a new source name, please contact your company AJINGA administrator or email <a href='mailTo:service@ajinga.com'>service@ajinga.com.</a>",
    sourceDetailTip: 'Not all users have the authority to create their own Source Name. If you don’t see your source name in the drop-down list and are unable to create a new source name, please contact your administrator or your AJINGA customer success consultant for support.',
    copyURLTip: 'Please press CTRL + C to copy the URL',
    selectAtLeastJob: 'Please select a job',
    refreshSuccess: 'Job(s) refreshed  successfully',
    closeJobTip: 'Confirm to close {count} jobs?',
    closeOneJobTip: 'Confirm to close this job?',
    refreshJobTip: 'Confirm to refresh {count} jobs post date?',
    refreshOneJobTip: 'Confirm to refresh this job post date?',
    cancelAction: 'Action cancelled',
    closingTips: 'Closing jobs, job list will be refreshed after closing is completed!',
    closingSuccess: 'Job(s) closed successfully',
    postingJobTips: 'Creating related tasks, please wait a moment',
    postingJobSuccess: 'Your task has been submitted successfully',
    setHotJobTips: 'Setting hot job, please wait a moment',
    setHotJobSuccess: 'Hot Job activated successfully',
    closeHotJobSuccess: 'Hot Job de-activated successfully ',
    deleteSuccess: 'Delete Success',
    closeJobSuccess: 'Job closed successfully',
    openJobSuccess: 'Job opened successfully',
    jobChannelChange: 'Job posting information has changed, refreshed job information, please wait for a moment',
    postToAgencySuccess: 'Your job has been posted to the agency successfully',
    postToAgencyEmpty: 'No job need posted to the agency, only open job can be posted',
    optionSuccess: 'Option Success',
    notAllowApplication: 'Oops! It seems you do not have permissions to view the candidate for this job. Please contact your administrator or your AJINGA customer success consultant for support.'
  }
}
